import { digitsOnly, result } from '../shared';

export const key = 'us_zip_code';

export const meta = {
  label: 'US ZIP Code',
  sensitive: false,
  allowed_contact_types: ['string'],
  allowed_form_types: ['Text'],
};

export function validate(value) {
  let digits = digitsOnly(value);
  if (!digits) {
    return result(false, '', 'US ZIP code is required');
  }

  if (digits.length !== 5) {
    let message = `US ZIP code must be exactly 5 digits (got ${digits.length})`;
    if (digits.length === 9) {
      message = 'US ZIP code must be 5 digits; ZIP+4 is not supported';
    }
    return result(false, digits, message);
  }

  const zip = parseInt(digits, 10);
  if (zip < 501 || zip > 99950) {
    return result(
      false,
      digits,
      'US ZIP code is outside the valid assigned range'
    );
  }

  return result(true, digits);
}

export function normalize(value) {
  const res = validate(value);
  return res.valid ? res.value : digitsOnly(value);
}

export function display(value) {
  const res = validate(value);
  return res.valid ? res.value : digitsOnly(value);
}

export function getInputProps() {
  return {
    mask: '#####',
    maxlength: 5,
    inputmode: 'numeric',
  };
}
